'use client'

import { useQuery } from '@tanstack/react-query'
import { getUserUncelebratedBadges } from '@/lib/badges/badge-actions'
import type { UserBadge } from '@/types/badges'

export function useUncelebratedBadges(enabled = true) {
  return useQuery<UserBadge[]>({
    queryKey: ['uncelebrated-badges'],
    queryFn: async () => {
      const result = await getUserUncelebratedBadges()
      if (!result.success) throw new Error(result.error)
      return result.data!
    },
    staleTime: 30 * 1000, // 30s - avoid refetch on every navigation
    gcTime: 0, // discard cache on unmount so stale data doesn't re-trigger celebrations
    refetchOnMount: 'always',
    enabled,
  })
}
